// @ts-ignore
export const isElectron = typeof process !== 'undefined' && process.type === 'renderer'
export const isAssistant = typeof window !== 'undefined' && window.__RENDERER_NAME === 'assistant'
export const isBaseApp = typeof window !== 'undefined' && window.__RENDERER_NAME === 'app'
